import React, { useState, useEffect } from "react";
import { Button, Drawer, Carousel } from "antd";
import {
  MenuOutlined,
  AppstoreOutlined,
  CaretDownOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../Redux/slice/categorySlice";
import { fetchBrands } from "../../Redux/slice/brandSlice";
import { getBannerPageAdvertisment } from "../../Redux/slice/advertismentSlice";
import "./Header.css";
import ban from "../../assets/ba.jpg";

const backendBaseURL = "https://smfteapi.salesmate.app";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [expandedCategoryId, setExpandedCategoryId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filteredAds, setFilteredAds] = useState([]);

  const dispatch = useDispatch();
  const { categories } = useSelector((state) => state.categories);
  const { brands } = useSelector((state) => state.brands);
  const { advertisments = [] } = useSelector((state) => state.advertisment);

  useEffect(() => {
    dispatch(fetchCategories());
    dispatch(fetchBrands());

    dispatch(getBannerPageAdvertisment())
      .then((response) => {
        if (response.payload && response.payload.length > 0) {
          setFilteredAds(response.payload);
        } else {
          setFilteredAds([]);
        }
      })
      .finally(() => setLoading(false));
  }, [dispatch]);

  /** ---------- Helpers ---------- */
  const renderCarouselContent = () => (
    <Carousel autoplay effect="fade" autoplaySpeed={5000} speed={500} dots>
      {/* Dynamic Banner Slides (index 0 upward) */}
      {filteredAds.map((ad, index) => (
        <div key={ad.id || index}>
          <img
            src={`${backendBaseURL}/Media/Ads/${ad.fileName.split("\\").pop()}`}
            alt={`Banner ${index + 1}`}
            className="w-full h-full object-cover rounded-lg"
          />
        </div>
      ))}
    </Carousel>
  );

  /** ---------- Render ---------- */
  return (
    <div className="container mx-auto p-2">
      <div className="flex flex-col md:flex-row relative bg-gray-30">
        {/* Desktop View */}
        <div className="hidden md:block w-full">
          {loading || filteredAds.length === 0 ? (
            <img
              src={ban}
              alt="Default Banner"
              className="w-full h-full object-cover rounded-lg"
            />
          ) : (
            renderCarouselContent()
          )}
        </div>

        {/* Mobile View */}
        <div className="md:hidden w-full relative">
          <div className="sticky top-0 left-0 w-full z-50 bg-red-500 p-2 rounded-xl">
            <Button
              type="text"
              icon={<MenuOutlined />}
              onClick={() => setIsMenuOpen(true)}
              className="text-sm text-white flex items-center justify-center"
            >
              <span className="ml-2">Categories</span>
            </Button>
          </div>

          <div className="carousel w-full h-auto mt-0.5">
            {loading || filteredAds.length === 0 ? (
              <img
                src={ban}
                alt="Default Mobile Banner"
                className="w-full h-full object-cover rounded-lg"
              />
            ) : (
              renderCarouselContent()
            )}
          </div>
        </div>

        {/* Sidebar Drawer */}
        <Drawer
          title="Categories"
          placement="left"
          width={300}
          onClose={() => setIsMenuOpen(false)}
          open={isMenuOpen}
          headerStyle={{
            backgroundColor: "#006838",
            color: "white",
            fontSize: "18px",
            fontWeight: "bold",
          }}
          bodyStyle={{ padding: "20px", backgroundColor: "#f8f8f8" }}
        >
          {categories
            .filter((c) => c.categoryName !== "Products out of stock")
            .map((category) => (
              <div key={category.categoryId} className="mb-4">
                {/* Category Title */}
                <div
                  className={`flex items-center justify-between cursor-pointer py-2 px-1 rounded-lg transition-all duration-300 ${
                    expandedCategoryId === category.categoryId
                      ? "bg-red-500 text-white"
                      : "hover:bg-red-400 hover:text-white text-gray-800"
                  }`}
                  onClick={() =>
                    setExpandedCategoryId(
                      expandedCategoryId === category.categoryId
                        ? null
                        : category.categoryId
                    )
                  }
                >
                  <div className="flex items-center">
                    <AppstoreOutlined className="text-xl text-white mr-3" />
                    <span className="text-lg font-medium">
                      {category.categoryName}
                    </span>
                  </div>
                  {expandedCategoryId === category.categoryId ? (
                    <CloseOutlined />
                  ) : (
                    <CaretDownOutlined />
                  )}
                </div>

                {/* Brand List */}
                {expandedCategoryId === category.categoryId && (
                  <div className="ml-6 mt-3 grid grid-cols-2 gap-2 max-h-48 overflow-y-auto">
                    {brands
                      .filter((b) => b.categoryId === category.categoryId)
                      .map((brand) => (
                        <div
                          key={brand.brandId}
                          className="py-1 px-1 text-center rounded-lg transition-all duration-300 hover:bg-red-400 hover:text-white"
                          style={{ backgroundColor: "#006838" }}
                        >
                          <span className="text-sm text-white">
                            {brand.brandName}
                          </span>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            ))}
        </Drawer>
      </div>
    </div>
  );
};

export default Header;
